module.exports = __webpack_public_path__ + "img/Certificate.4ede146d.jpg";